import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/(generated)/unified-social-customer-care-for-retail/Body.jsx");
